// pages/index.js
import ContactPage from 'src/components/More/ContactPage';
import { Layout as UserLayout } from "src/layouts/userlayout/layout";
function Page() {
  return <div>
    <ContactPage />
  </div>;
}

Page.getLayout = (page) => (
  <UserLayout>
    {page}
  </UserLayout>
);

export default Page;